
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"31","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1284_60622)","fill":"#EDC843"}},[_c('path',{attrs:{"d":"M28.005 16.311a.88.88 0 010-.777l1.12-2.289A2.604 2.604 0 0028 9.787l-2.25-1.194a.88.88 0 01-.457-.629l-.44-2.51a2.604 2.604 0 00-2.942-2.137l-2.523.357a.88.88 0 01-.739-.24l-1.83-1.771a2.604 2.604 0 00-3.637 0L11.35 3.434a.88.88 0 01-.74.24L8.09 3.317a2.604 2.604 0 00-2.942 2.138l-.44 2.51a.88.88 0 01-.457.628L2 9.787a2.604 2.604 0 00-1.124 3.458l1.119 2.29a.88.88 0 010 .776l-1.119 2.29A2.604 2.604 0 002 22.058l2.25 1.194a.88.88 0 01.457.629l.44 2.51a2.603 2.603 0 002.942 2.136l2.523-.356a.879.879 0 01.739.24l1.83 1.771a2.607 2.607 0 003.637 0l1.831-1.771a.88.88 0 01.74-.24l2.522.356a2.604 2.604 0 002.942-2.137l.44-2.51a.88.88 0 01.457-.628L28 22.059a2.604 2.604 0 001.124-3.459l-1.119-2.289zM11.54 8.137a3.176 3.176 0 013.173 3.172 3.176 3.176 0 01-3.173 3.172 3.176 3.176 0 01-3.172-3.172 3.176 3.176 0 013.172-3.172zM9.902 22.244a.863.863 0 01-1.223 0 .865.865 0 010-1.223L20.098 9.6a.865.865 0 011.223 1.224L9.902 22.245zm8.559 1.465a3.176 3.176 0 01-3.173-3.172 3.176 3.176 0 013.172-3.172 3.176 3.176 0 013.173 3.172 3.176 3.176 0 01-3.172 3.172z"}}),_c('path',{attrs:{"d":"M18.46 19.095c-.795 0-1.441.647-1.441 1.442 0 .795.646 1.442 1.442 1.442.795 0 1.441-.647 1.441-1.442 0-.795-.646-1.442-1.442-1.442zM11.54 9.867c-.796 0-1.442.647-1.442 1.442 0 .795.646 1.442 1.441 1.442.796 0 1.442-.647 1.442-1.442 0-.795-.646-1.442-1.442-1.442z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1284_60622"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .923)","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    